import JavaScript from './components/JavaScript';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import MainLayout from './layouts/MainLayout';

import Dashboard from './pages/Dashboard';
import Setting from './pages/Setting';
import Login from './pages/Login';
import UserRegistration from './pages/UserRegistration';
import Company from './pages/Company';
import SendEmailSetting from './pages/SendEmailSetting';
import CompanyDefaultSetting from './pages/CompanyDefaultSetting';
import CompanyDetails from './pages/CompanyDetails';
import UserInquiry from './pages/UserInquiry';
import CallbackUrl from './pages/CallbackUrl';
import Badge from './pages/Badge';
import AddBadge from './pages/AddBadge';
import S3Bucket from './pages/S3Bucket';
import CopyRecord from './pages/CopyRecord';
import ProfileStatus from './pages/ProfileStatus';
import SendEmail from './pages/SendEmail';
import News from './pages/News'
import HealthCheck from './pages/HealthCheck';
import AddNews from './pages/AddNews'
import Group from './pages/Group';
import AddGroup from './pages/AddGroup';
function App() {
  return (
    <Router>

      <Routes>
        {/* Public Route - No Layout */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes - With Layout */}
        <Route
          path="/dashboard"
          element={
            <MainLayout>
              <Dashboard />
            </MainLayout>
          }
        />
        <Route
          path="/setting"
          element={
            <MainLayout>
              <Setting />
            </MainLayout>
          }
        />
        <Route
          path="/company"
          element={
            <MainLayout>
              <Company />
            </MainLayout>
          }
        />
        <Route
          path="/group"
          element={
            <MainLayout>
              <Group />
            </MainLayout>
          }
        />
        <Route
          path="/group/add"
          element={
            <MainLayout>
              <AddGroup />
            </MainLayout>
          }
        />
        <Route
          path="/group/add/:id"
          element={
            <MainLayout>
              <AddGroup />
            </MainLayout>
          }
        />
        <Route
          path="/health-check"
          element={
            <MainLayout>
              <HealthCheck />
            </MainLayout>
          }
        />
        <Route
          path="/news"
          element={
            <MainLayout>
              <News />
            </MainLayout>
          }
        />
        <Route
          path="/news/add/:id"
          element={
            <MainLayout>
              <AddNews />
            </MainLayout>
          }
        />
        <Route
          path="/news/add/"
          element={
            <MainLayout>
              <AddNews />
            </MainLayout>
          }
        />
        <Route
          path="/user-inquiry"
          element={
            <MainLayout>
              <UserInquiry />
            </MainLayout>
          }
        />
        <Route
          path="/send-email-setting"
          element={
            <MainLayout>
              <SendEmailSetting />
            </MainLayout>
          }
        />

        <Route
          path="/s3-bucket"
          element={
            <MainLayout>
              <S3Bucket />
            </MainLayout>
          }
        />
        <Route
          path="/copy-record"
          element={
            <MainLayout>
              <CopyRecord />
            </MainLayout>
          }
        />

        <Route
          path="/profile-status"
          element={
            <MainLayout>
              <ProfileStatus />
            </MainLayout>
          }
        />

        <Route
          path="/send-email"
          element={
            <MainLayout>
              <SendEmail />
            </MainLayout>
          }
        />

        <Route
          path="/company-default-setting"
          element={
            <MainLayout>
              <CompanyDefaultSetting />
            </MainLayout>
          }
        />
        <Route
          path="/company-details"
          element={
            <MainLayout>
              <CompanyDetails />
            </MainLayout>
          }
        />

        <Route
          path="/callback-url"
          element={
            <MainLayout>
              <CallbackUrl />
            </MainLayout>
          }
        />
        <Route
          path="/badge"
          element={
            <MainLayout>
              <Badge />
            </MainLayout>
          }
        />

        <Route
          path="/badge/add/:cid"
          element={
            <MainLayout>
              <AddBadge />
            </MainLayout>
          }
        />
        <Route
          path="/badge/edit/:cid/:main"
          element={
            <MainLayout>
              <AddBadge />
            </MainLayout>
          }
        />

        <Route
          path="/registration"
          element={
            <MainLayout>
              <UserRegistration />
            </MainLayout>
          }
        />
        <Route
          path="/registration/:cid"
          element={
            <MainLayout>
              <UserRegistration />
            </MainLayout>
          }
        />
        <Route
          path="/registration/:cid/:mm"
          element={
            <MainLayout>
              <UserRegistration />
            </MainLayout>
          }
        />

        <Route
          path="/registration/:uid/edit-user"
          element={
            <MainLayout>
              <UserRegistration />
            </MainLayout>
          }
        />

      </Routes>

      <JavaScript />
    </Router>
  );
}

export default App;